export default "__VITE_ASSET__BZHnM832__"